import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { useCallback, useEffect } from "react";
import { FolderTreeDragHelper, useJqueryFolderTreeDraggable } from "@devowl-wp/react-folder-tree";
import { isAttachmentsGalleryEdit } from "../../../backbone/modal.js";
import { useAppTreeControllerRef } from "../../../contexts/appTreeControllerContext.js";
import { useAppTreeLocalState } from "../../../contexts/appTreeLocalStateContext.js";
import { useAppTreeMountContext } from "../../../contexts/appTreeMountContext.js";
import { __ } from "../../../utils/i18n.js";
const LIST_TABLE_DRAG_TARGET = "#wpbody-content .wp-list-table tbody tr:not(.no-items)";
function iterateDraggedItem(ui, container, listMode, gridMode) {
    const { attachmentsBrowser } = container;
    if (attachmentsBrowser) {
        const browser = attachmentsBrowser;
        const selection = browser.options.selection.models;
        if (selection.length) {
            selection.forEach((model)=>{
                gridMode?.(model.attributes, attachmentsBrowser);
            });
            return selection.length;
        }
        const id = ui.data("id");
        gridMode?.(browser.collection.models.filter((model)=>model.id === id)[0], attachmentsBrowser);
        return 1;
    }
    const trs = $("#the-list > tr > .check-column > input:checked");
    if (trs.length) {
        trs.each(function() {
            listMode?.($(this).parents("tr"));
        });
    } else {
        listMode?.(ui);
    }
    return trs.length || 1;
}
function useAttachmentDraggable() {
    const controllerRef = useAppTreeControllerRef();
    const { attachmentsBrowser } = useAppTreeMountContext();
    const { isMoveable, isWPAttachmentsSortMode } = useAppTreeLocalState();
    const renderHelper = useCallback((count)=>/*#__PURE__*/ _jsx(FolderTreeDragHelper, {
            moveLabel: count > 1 ? __("Move %d files", count) : __("Move one file"),
            moveHint: __("Hold any key to create a shortcut"),
            appendLabel: count > 1 ? __("Copy %d files", count) : __("Copy one file"),
            appendHint: __("Release key to move file")
        }), []);
    const getDragCount = useCallback((event)=>iterateDraggedItem($(event.currentTarget), controllerRef.current), [
        controllerRef
    ]);
    const resolveTarget = useCallback(()=>{
        const browser = controllerRef.current.attachmentsBrowser;
        return browser ? browser.$el.find("ul.attachments > li") : LIST_TABLE_DRAG_TARGET;
    }, [
        controllerRef
    ]);
    const bindDraggable = useJqueryFolderTreeDraggable({
        $,
        target: LIST_TABLE_DRAG_TARGET,
        resolveTarget,
        getDragCount,
        renderHelper
    });
    const makeDraggable = useCallback((destroy)=>{
        const element = controllerRef.current;
        const browser = element.attachmentsBrowser;
        const attachments = browser?.attachments;
        const target = browser ? browser.$el.find("ul.attachments > li") : $(LIST_TABLE_DRAG_TARGET);
        const isGalleryEdit = isAttachmentsGalleryEdit(attachments);
        if (destroy || !element.state.isMoveable || element.state.isWPAttachmentsSortMode || isGalleryEdit || document.documentElement.clientWidth <= 900) {
            try {
                target.draggable("destroy");
            } catch  {
            // Silence is golden.
            }
            if (isGalleryEdit && attachments) {
                attachments.collection.comparator = undefined;
                attachments.initSortable();
            }
            return;
        }
        bindDraggable();
    }, [
        bindDraggable,
        controllerRef
    ]);
    useEffect(()=>{
        controllerRef.current.makeDraggable = makeDraggable;
        return ()=>{
            delete controllerRef.current.makeDraggable;
        };
    }, [
        controllerRef,
        makeDraggable
    ]);
    useEffect(()=>{
        makeDraggable();
        return ()=>makeDraggable(true);
    }, [
        makeDraggable,
        isMoveable,
        isWPAttachmentsSortMode,
        attachmentsBrowser
    ]);
    return makeDraggable;
}
export { useAttachmentDraggable };
